import { render, staticRenderFns } from "./CatalogCategory.vue?vue&type=template&id=22ad3619&"
import script from "./CatalogCategory.vue?vue&type=script&lang=js&"
export * from "./CatalogCategory.vue?vue&type=script&lang=js&"
import style0 from "./CatalogCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports